import styled from "styled-components";

import { StyledTable } from "@styles/components/Table.styled";
import { alignItemsCenter, pseudo, rem } from "@styles/Utilities.styled";


export const StyledLabTabTable = styled(StyledTable)`
  .type-wrapper {
    ${alignItemsCenter}
    gap: 0.5rem;

    svg {
      path {
        stroke: var(--clr-accent);
      }
    }
  }

  .file-type-icon-wrapper {
    ${alignItemsCenter}
    gap: 0;
    isolation: isolate;

    /* &.multiple-different {
      .icon-wrapper:first-child {
        transform: rotate(-13deg) translateX(20%);
        z-index: 1;
      }
      .icon-wrapper:last-child {
        transform: rotate(13deg) translateX(-20%);
      }
    } */

    &.multiple-same,
    &.multiple-different {
      .icon-wrapper:first-child {
        z-index: 1;
      }
      .icon-wrapper:last-child {
        transform: translate(-60%, -10%);
      }
    }
  }

  .icon-wrapper {
    position: relative;
    flex-grow: 0;
    transform-origin: center;
    margin-bottom: -5px;
    transition: transform 0.1s;

    &::before {
      ${pseudo}
      top: 0;
      left: 0;
      width: 95%;
      height: 85%;
      background-color: var(--clr-white);
      clip-path: polygon(0 0, 75% 0, 100% 25%, 100% 100%, 0 100%);
      z-index: -1;
    }

    &.pdf {
      /* color: var(--blue-9); */
      color: var(--clr-primary-400);
    }

    &.image {
      /* color: var(--green-9); */
      color: var(--orange-10);
    }

    .file-type-icon {
      font-size: ${rem(24)};
      color: inherit;
      /* outline: 1px solid blue; */
      z-index: 1;
    }
  }

  tr:hover {
    .file-type-icon-wrapper {
      &.multiple-different {
        .icon-wrapper:last-child {
          transform: rotate(13deg) translateX(-20%);
        }
      }
    }
    .icon-wrapper::before {
      background-color: var(--clr-gray-100);
    }
  }

  .bolt-icon {
    color: var(--clr-yellow);
    font-size: 1.1rem;
  }

  th,
  td {
    &:first-child {
      padding-right: 0.5em !important;
      /* width: ${rem(45)}; */
      min-width: ${rem(60)};
      /* outline: 1px solid red; */
    }
  }

  tr.is-general {
    cursor: pointer !important;
  }
`;
